export default "__VITE_ASSET__BfS8cQlL__"